<script>
export default {
  props: ["variant"],
  data: function () {
    return {
      opened: false,
    };
  },
  methods: {
    toggle: function () {
      this.opened = !this.opened;
      this.$emit("update:opened", this.opened);
    },
    close: function () {
      this.opened = false;
      this.$emit("update:opened", this.opened);
    },
  },
};
</script>

<template>
  <div class="f-drop-down-box" v-click-outside="close" :class="[variant]">
    <slot name="button" :class="{ active: opened }"></slot>

    <div class="f-drop-down-box-box" v-if="opened">
      <f-icon class="f-drop-down-box-box-arrow" icon="fg-arrow-black"></f-icon>

      <slot name="dropdown"></slot>
    </div>
  </div>
</template>

<style lang="scss">
.f-drop-down-box {
  position: relative;

  .f-drop-down-box-box {
    position: absolute;
    width: 240px;
    left: calc(
      50% - 48px
    ); // 28=arrow left (12) - half arrow width (8) - padding left (8)
    top: calc(100% + 8px);
    z-index: 1000;
    background: white;
    border-radius: 8px;
    box-shadow: 0px 24px 48px 0px rgba(22, 22, 21, 0.25);
    padding: 16px;

    .f-drop-down-box-box-arrow {
      position: absolute;
      top: -8px;
      left: 12px;
      width: 16px;
      height: 8px;
    }
  }
  
  &.rightbox .f-drop-down-box-box {
    bottom: calc(
      50% - 48px
    ); // 28=arrow left (12) - half arrow width (8) - padding left (8)
    left: calc(100% + 8px);
    top: inherit;

    .f-drop-down-box-box-arrow {
      display: none;
    }
  }
}

.f-drop-down-box.rightanchor {
  .f-drop-down-box-box {
    right: calc(
      50% - 28px
    ); // 28=arrow left (12) - half arrow width (8) - padding left (8)
    right: 0;
    left: auto;

    .f-drop-down-box-box-arrow {
      top: -8px;
      left: auto;
      right: 12px;
      width: 16px;
      height: 8px;
    }
  }
}

.dark-mode {
  .f-drop-down-box {
    color: var(--white-a75);

    .f-drop-down-box-box {
      background: #000;
      box-shadow: 0 24px 48px rgb(0 0 0 / 40%);

      .f-form {
        background: #000;
      }
    }
  }
}
</style>